/*
 * ANIME CRUSH — DIRECT VARIANT PICKER
 *
 * THE CONTRACT
 * The form's variant control is the native <select name="id"> the theme
 * already renders. This file SETS it and never replaces it, so Add to Cart and
 * the dynamic checkout button submit the variant the customer actually chose.
 * A selector that looks right while the form posts something else is the
 * failure this is written to avoid, so the select is the single source of
 * truth and everything visible is derived from it.
 *
 * ON EVERY CHANGE it updates: the selected variant id in the form, the price,
 * the compare-at price, availability, the Add to Cart label and disabled
 * state, the ?variant= URL, and the gallery image where the variant has one.
 *
 * UNAVAILABLE COMBINATIONS are disabled rather than hidden, because a size
 * that silently disappears when you change colour is more confusing than one
 * that is visibly out of stock.
 */
(function () {
  'use strict';

  /*
   * This shop's money_format is
   *     <span class=money>${{amount}}</span>
   * so it carries MARKUP. Writing it with textContent prints the tags as
   * literal text - the first build of this produced
   *     Add to cart · <span class=money>$42.99</span>
   * on the button. The tags are stripped here and the plain string is written
   * into whatever element already exists for it.
   */
  function moneyText(format, cents) {
    var amount = (cents / 100).toFixed(2);
    var s = format
      ? format.replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
              .replace(/\{\{[^}]*\}\}/, amount)
      : '$' + amount;
    return s.replace(/<[^>]*>/g, '').trim();
  }

  /*
   * Write into the theme's own .money span when there is one. A currency
   * converter app hangs off [data-money-convertible] > .money, and replacing
   * that structure would silently break conversion.
   */
  function setMoney(el, format, cents) {
    var text = moneyText(format, cents);
    var inner = el.querySelector ? el.querySelector('.money') : null;
    if (inner) inner.textContent = text;
    else el.textContent = text;
  }

  function setup(root) {
    var dataEl = root.querySelector('[data-ac-variant-data]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;

    var form = root.closest('form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var select = form.querySelector('select[name="id"], input[name="id"]');
    if (!select) return;

    /*
     * Captured ONCE, before anything is written, so the button's own label
     * survives. Read it back after an update and you read your own output.
     */
    var atc = form.querySelector('.ProductForm__AddToCart, button[name="add"], button[type="submit"]');
    var atcLabel = atc ? atc.querySelector('span:not([data-money-convertible]):not(.Button__SeparatorDot):not(.money)') : null;
    var atcLabelText = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';
    var atcPrice = atc ? atc.querySelector('[data-money-convertible]') : null;
    var atcDot = atc ? atc.querySelector('.Button__SeparatorDot') : null;

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ac-option]'));
    var note = root.querySelector('[data-ac-picker-note]');

    /* Current selection, seeded from whatever the form already holds. */
    var current = (function () {
      var v = data.variants.filter(function (x) { return String(x.id) === String(select.value); })[0];
      return (v || data.variants[0]).options.slice();
    })();

    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(v.options[j]) !== String(opts[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* Is there ANY variant with this value at this position, given the other
     * choices? Used to disable combinations that do not exist. */
    function combinationExists(position, value) {
      var probe = current.slice();
      probe[position] = value;
      var v = findVariant(probe);
      return { exists: !!v, available: !!(v && v.available) };
    }

    function paintAvailability() {
      groups.forEach(function (g) {
        var pos = Number(g.getAttribute('data-ac-option')) - 1;
        Array.prototype.forEach.call(g.querySelectorAll('[data-ac-value]'), function (btn) {
          var state = combinationExists(pos, btn.getAttribute('data-ac-value'));
          var dead = !state.exists || !state.available;
          btn.classList.toggle('is-unavailable', dead);
          btn.setAttribute('aria-disabled', dead ? 'true' : 'false');
          /* Not `disabled`: a disabled button cannot receive focus, and a
           * keyboard user should still be able to land on a sold-out size and
           * be told it is sold out. */
        });
      });
    }

    function paintSelection() {
      groups.forEach(function (g) {
        var pos = Number(g.getAttribute('data-ac-option')) - 1;
        var chosen = g.querySelector('[data-ac-chosen]');
        if (chosen) chosen.textContent = current[pos];
        Array.prototype.forEach.call(g.querySelectorAll('[data-ac-value]'), function (btn) {
          var on = btn.getAttribute('data-ac-value') === current[pos];
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.tabIndex = on ? 0 : -1;
        });
      });
    }

    function updatePrice(v) {
      var meta = document.querySelector('.ProductMeta') || document;
      Array.prototype.forEach.call(
        meta.querySelectorAll('.ProductMeta__Price:not(.Price--compareAt)'),
        function (el) { setMoney(el, data.moneyFormat, v.price); }
      );
      Array.prototype.forEach.call(
        meta.querySelectorAll('.ProductMeta__Price.Price--compareAt'),
        function (el) {
          var on = !!(v.comparePrice && v.comparePrice > v.price);
          if (on) setMoney(el, data.moneyFormat, v.comparePrice);
          el.hidden = !on;
          el.style.display = on ? '' : 'none';
        }
      );
    }

    /*
     * Prestige's button is already three nodes:
     *     <span>Add to cart</span><span class="Button__SeparatorDot"></span>
     *     <span data-money-convertible><span class="money">$42.99</span></span>
     * so the label must NOT be given the price as well. Writing
     * "Add to cart · $42.99" into the first span printed the amount twice.
     */
    function updateAddToCart(v) {
      if (!atc) return;
      var label = atcLabel || atc;
      var showPrice = !!(v && v.available);

      if (!v) { atc.setAttribute('disabled', 'disabled'); label.textContent = 'Unavailable'; }
      else if (!v.available) { atc.setAttribute('disabled', 'disabled'); label.textContent = 'Sold out'; }
      else { atc.removeAttribute('disabled'); label.textContent = atcLabelText; }

      if (atcPrice) {
        if (showPrice) setMoney(atcPrice, data.moneyFormat, v.price);
        atcPrice.hidden = !showPrice;
        atcPrice.style.display = showPrice ? '' : 'none';
      }
      if (atcDot) atcDot.style.display = showPrice ? '' : 'none';
    }

    /*
     * GALLERY FOLLOWS THE VARIANT (fixed 2026-11-04, owner report: picking
     * "Dress (white)" left the photo on the ivory dress).
     *
     * The first version looked for [data-media-id=<featured_media.id>], but the
     * gallery cells carry data-image-id=<featured_image.id>, a DIFFERENT number,
     * so it never found anything; and on phones the gallery is a Flickity
     * carousel, where scrollIntoView does nothing. Prestige already knows how
     * to move its own gallery (carousel on phones, thumbnail/dot link on wider
     * screens): it listens for `variant:changed` on the product section. Its
     * own variant script fired that event, ours did not. So we fire it, with
     * the shape its handler reads: detail.variant.featured_image.id.
     */
    var lastVariant = null;
    function updateMedia(v) {
      if (!v) return;
      var variant = { id: v.id, featured_image: v.imageId ? { id: v.imageId } : null };
      var prev = lastVariant;
      lastVariant = variant;
      if (!prev) return; /* first paint: Liquid already opened on this image */
      if (!v.imageId || (prev.featured_image && prev.featured_image.id === v.imageId)) return;

      if (window.matchMedia('(max-width: 1007px)').matches) {
        /* Phone/tablet: Flickity carousel. Prestige's handler selects the cell. */
        form.dispatchEvent(new CustomEvent('variant:changed', {
          bubbles: true,
          detail: { variant: variant, previousVariant: prev }
        }));
        return;
      }

      /* Desktop: the photos are stacked. Prestige's own route (clicking the
       * thumbnail link) landed on the wrong photo in tests for the first and
       * last images, so scroll to the variant's photo directly, just under the
       * sticky header. */
      var cell = document.querySelector('.Product__Slideshow .Product__SlideItem[data-image-id="' + v.imageId + '"]');
      if (!cell) return;
      var header = document.querySelector('.shopify-section--header');
      var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var top = cell.getBoundingClientRect().top + window.pageYOffset - offset - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function updateUrl(v) {
      if (!v || !window.history || !window.history.replaceState) return;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }

    function apply(v, opts) {
      if (!v) {
        if (note) {
          note.textContent = 'That combination is not available. Try another ' +
            (opts && opts.name ? opts.name.toLowerCase() : 'option') + '.';
          note.hidden = false;
        }
        updateAddToCart(null);
        return;
      }
      if (note) { note.hidden = true; note.textContent = ''; }

      if (select.tagName === 'SELECT') {
        select.value = String(v.id);
      } else {
        select.value = String(v.id);
      }
      /* Announce it, in case anything else on the page is listening. */
      select.dispatchEvent(new Event('change', { bubbles: true }));

      updatePrice(v);
      updateAddToCart(v);
      updateUrl(v);
      updateMedia(v);
    }

    function choose(position, value, groupName) {
      current[position] = value;
      paintSelection();
      paintAvailability();
      apply(findVariant(current), { name: groupName });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ac-value]');
      if (!btn) return;
      e.preventDefault();
      var g = btn.closest('[data-ac-option]');
      choose(Number(g.getAttribute('data-ac-option')) - 1,
             btn.getAttribute('data-ac-value'),
             g.getAttribute('aria-label'));
      /* preventScroll: a plain focus() cancels the smooth scroll to the
       * variant's photo that choose() has just started on desktop. */
      btn.focus({ preventScroll: true });
    });

    /* Arrow keys move within a group, as a radiogroup should. */
    root.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-ac-value]');
      if (!btn) return;
      var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', ' ', 'Enter'];
      if (keys.indexOf(e.key) < 0) return;
      var g = btn.closest('[data-ac-option]');
      var all = Array.prototype.slice.call(g.querySelectorAll('[data-ac-value]'));
      var i = all.indexOf(btn);
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        btn.click();
        return;
      }
      e.preventDefault();
      var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? i + 1 : i - 1;
      next = (next + all.length) % all.length;
      all[next].focus();
      all[next].click();
    });

    form.classList.add('ac-picker-active');
    paintSelection();
    paintAvailability();
    /* Seed the display from the variant the form already holds, so price and
     * button text are right before anything is clicked. */
    apply(findVariant(current), {});
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ac-picker]'), setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
